import { Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { ITaskSearchParam } from 'wisestep-api';
import {
  Item,
  WsTypography,
  WsTaskCard,
  WsDialog,
  WsButton,
  IConversationState,
  WsListingLoader,
} from 'wisestep-base';

import { WsTaskCreationCard } from '../../../components/WsTaskCreationCard';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { openUrlInNewTab } from '../../../utils/openUrlInNewTab';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';
import useTaskSearch from '../../tasks/hooks/useTaskSearch';
import { TaskDefaultQuery } from '../../tasks/TaskDefaultQuery';
import { closeTask } from '../../tasks/utils/TaskHelper';

interface ITasks {
  state?: IConversationState;
  hideEmptyScreen?: boolean;
}

const InteractionTaskList = ({ state, hideEmptyScreen = false }: ITasks) => {
  const candidate = state?.candidate;
  const [selectedTaskIndex, setSelectedTaskIndex] = useState<number>(-1);
  const [query, setQuery] = useState<ITaskSearchParam>(TaskDefaultQuery);
  query.size = 5;
  query.searchType = 'workspace';
  query.taskAttributes = {
    candidateEmail: candidate?.email,
    candidateName: candidate?.name,
    candidatePhone: candidate?.phoneNumber,
    jobCode: candidate?.jobCode,
  };
  const [loader, setLoader] = useState<boolean>(false);
  const [createTask, setCreateTask] = useState<boolean>(false);
  const [tasks, taskCount] = useTaskSearch(query, setLoader);
  const updateAction = useConversationWidgetStore((state) => state.updateAction);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const openModal = useConversationWidgetStore((state) => state.updateId);

  const onCVClick = (id: string) => {
    if (id) openModal(id);
  };

  const onCompleteTask = async (taskId: string) => {
    setNotification(await closeTask(taskId));
    setQuery({ ...query });
  };

  return (
    <Grid item xs={12}>
      {!loader ? (
        <>
          {taskCount > 0 ? (
            <Grid sx={{ overflowY: 'auto' }}>
              {tasks?.map((task, index) => (
                <Item sx={{ pb: 0 }} key={index}>
                  <WsTaskCard
                    title={task.title ? task.title : ''}
                    description={
                      task.attributes &&
                      `${task.recruiterName ?? ''} has a task about 
                              ${task.attributes.jobTitle ?? ''} with 
                              ${task.attributes.candidateName ?? ''}`
                    }
                    date={task.dueDate ? task.dueDate.toString() : task?.modifiedOn.toString()}
                    jobRole={
                      task.attributes && task.attributes?.jobTitle
                        ? `${task.attributes?.jobTitle}`
                        : 'Job title not available'
                    }
                    jobCode={
                      (task.attributes && `${task.attributes.jobCode}`) ?? 'Job code not available'
                    }
                    onJobTitleClick={(selectedJobId) =>
                      openUrlInNewTab(`/jobs-crm/${selectedJobId}/false/0/pipeline`)
                    }
                    checkBoxNeeded={false}
                    createdBy={task.recruiterName ?? ''}
                    createdByImgUrl={task.createdBy}
                    activeUsers={[]}
                    onCandidateNameClick={() => onCVClick(task.entityId)}
                    taskStatus={task.status}
                    taskDueDate={task.dueDate}
                    jobId={task.attributes?.recruiterJobMappingId ?? ''}
                    onSnoozeClick={() => {
                      setSelectedTaskIndex(index);
                      setCreateTask(!createTask);
                    }}
                    onEditClick={() => {
                      setSelectedTaskIndex(index);
                      setCreateTask(!createTask);
                    }}
                    onCompleteTask={() => onCompleteTask(task.id)}
                    taskDescription={task.description ?? ''}
                  />
                </Item>
              ))}
            </Grid>
          ) : (
            <>
              {hideEmptyScreen ? (
                <></>
              ) : (
                <Grid mt={25} container justifyContent="center">
                  <Stack direction="column">
                    <WsTypography>No reminder created!</WsTypography>
                    <WsButton onClick={() => updateAction('task')} variant="text">
                      Add Reminder
                    </WsButton>
                  </Stack>
                </Grid>
              )}
            </>
          )}
        </>
      ) : (
        <WsListingLoader />
      )}
      <WsDialog openDialog={createTask}>
        <WsTaskCreationCard
          updateTaskProp={true}
          taskDetails={tasks[selectedTaskIndex]}
          closeDialog={() => setCreateTask(!createTask)}
        />
      </WsDialog>
    </Grid>
  );
};

export default InteractionTaskList;
